var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "appContainer" }, [
    _c("div", [
      _c("header", [
        _c(
          "div",
          [
            _c(
              "keep-alive",
              [
                _c("dsio-engine", {
                  attrs: {
                    filters: _vm.filters,
                    displayMore: _vm.moreFilters,
                    counter: _vm.counter,
                    nbVisibleFilters:
                      _vm.isMobileScreen && _vm.moreFilters
                        ? 0
                        : _vm.nbVisibleFilters,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", [
          _c(
            "div",
            [
              _c("div", [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.counter) } }),
              ]),
              _c(
                "keep-alive",
                [
                  _c("dsio-sort", {
                    attrs: {
                      sorts: _vm.sorts,
                      sortBy: _vm.app.state.sortBy,
                      sortPrefix: _vm.t.sortPrefix,
                      sortDesc: _vm.sortDesc,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.app.params.userPosition,
                      expression: "app.params.userPosition",
                    },
                  ],
                },
                [
                  _c(
                    "keep-alive",
                    [
                      _vm.app.params.userPosition
                        ? _c("dsio-user-pos", {
                            attrs: {
                              sort: _vm.sorts.proximite ? "proximite" : null,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", [_c("keep-alive", [_c("dsio-context-filters")], 1)], 1),
              _c(
                "keep-alive",
                [
                  _vm.filters.geo
                    ? _c("dsio-mods", {
                        attrs: {
                          viewMods: _vm.app.params.viewMods,
                          defaultViewMod: _vm.defaultViewMod,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { ref: "appBody" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.listActive,
                expression: "listActive",
              },
            ],
            staticClass: "list-wrapper lcol",
            class: { loading: _vm.loading, loadingMore: _vm.loadingMore },
          },
          [
            _c("dsio-list", {
              attrs: { list: _vm.list, loading: _vm.loading },
            }),
            _vm.pagination
              ? _c("dsio-pagination", { attrs: { html: _vm.pagination } })
              : _vm._e(),
          ],
          1
        ),
        _vm.filters.geo
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mapActive,
                    expression: "mapActive",
                  },
                ],
              },
              [
                _c(
                  "div",
                  [
                    _vm.mapActive
                      ? _c("dsio-map", {
                          attrs: {
                            id: "geo",
                            mapItems: _vm.mapItems,
                            bounds:
                              _vm.mapConf.keepModChangeMapState &&
                              _vm.app.state.savedMapBounds
                                ? _vm.app.state.savedMapBounds
                                : _vm.bounds,
                            conf: _vm.mapConf,
                          },
                          on: {
                            popupOpen: function ($event) {
                              _vm.mapPopupOpen = true
                            },
                            popupClose: function ($event) {
                              _vm.mapPopupOpen = false
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm.app.params.detailPopup
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.oiId,
                expression: "oiId",
              },
            ],
            staticClass: "dsio-detail",
          },
          [
            _c("dsio-detail", {
              attrs: {
                oiId: _vm.oiId,
                sortedIds: _vm.sortedIds,
                conf: _vm.staticConf.detail,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }